import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Services } from "./components/Services";
import { WhyUs } from "./components/WhyUs";
import { Reviews } from "./components/Reviews";
import { ServiceArea } from "./components/ServiceArea";
import { Footer } from "./components/Footer";
import { FloatingBar } from "./components/FloatingBar";
import NeighborhoodPage from "./pages/NeighborhoodPage";
import ServicePage from "./pages/ServicePage";

const Home = () => (
  <>
    <Hero />
    <Marquee />
    <Services />
    <WhyUs />
    <Reviews />
    <ServiceArea />
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.09 });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App bg-[#070A0F] text-slate-50 min-h-screen antialiased" data-testid="app-root">
          <Header />
          <main className="pb-20 md:pb-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/mahalle/:slug" element={<NeighborhoodPage />} />
              <Route path="/hizmet/:slug" element={<ServicePage />} />
            </Routes>
          </main>
          <FloatingBar />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
